import { TransactionStatusTag } from "../../components/common/registerUtils";
import { formatCurrency, formatDateTime } from "../../utils/helpers";

export const useUserTransactions = () => {
  const tableColumns = () => [
    {
      id: "transaction_id",
      header: "Transaction ID",
      filter: {},
    },
    {
      id: "item_name",
      header: "Payment Item",
      filter: {},
    },
    {
      id: "customer_number",
      header: "Customer Number",
      filter: {},
    },
    {
      id: "amount",
      header: "Amount",
    },
    {
      id: "reference",
      header: "Reference",
      filter: {},
    },
    {
      id: "status",
      header: "Status",
      filter: {
        type: "text",
      },
    },
    {
      id: "final_status",
      header: "Final Status",
      filter: {
        type: "text",
      },
    },
    {
      id: "payment_date",
      header: "Payment Date",
      filter: {
        type: "date",
      },
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        amount: formatCurrency(item?.amount),
        status: <TransactionStatusTag status={item?.status} />,
        final_status: <TransactionStatusTag status={item?.final_status} />,
        payment_date: formatDateTime(item?.payment_date),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Transaction Details",
          fields: {
            transaction_id: item?.transaction_id,
            payment_item: item?.item_name,
            customer_number: item?.customer_number,
            amount: formatCurrency(item?.amount),
            reference: item?.reference,
            status: <TransactionStatusTag status={item?.status} />,
            final_status: <TransactionStatusTag status={item?.final_status} />,
            payment_date: formatDateTime(item?.payment_date),
          },
        },
      ],
    };
  };

  return { tableData, tableColumns, viewData };
};
